"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Pagination = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

var _Dropdown = _interopRequireDefault(require("../baseComponents/Dropdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Pagination = function Pagination(props) {
  //perPage props
  var values = props.values;
  var perPageValues = values.map(function (el, index) {
    return {
      "value": "".concat(el),
      "label": /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, el, " ", props.perPageText),
      "selected": el == props.perPage
    };
  }); //pagination props

  var totalPages = Math.ceil(props.currentCount / props.perPage);
  if (totalPages === 0) totalPages = 1;
  var nextPageDisabled = props.page === totalPages;
  var previousPageDisabled = props.page === 1; //React state hook

  var _useState = (0, _react.useState)(props.page),
      _useState2 = _slicedToArray(_useState, 2),
      userPage = _useState2[0],
      setUserPage = _useState2[1]; //On change of value of page or props.limit, set userInput value to the calculated page


  (0, _react.useEffect)(function () {
    setUserPage(props.page);
  }, [props.page, props.limit]);

  function onUserInputChange(event) {
    // Validate user input
    if (isNaN(event.target.value)) return;
    var value = parseInt(event.target.value);
    if (value < 1) value = 1;
    if (value > totalPages) value = totalPages;
    props.onChange(event, props.perPage, value, "input");
  }

  ;
  var linkNext = "";
  var linkPrev = "";

  if (props.toLink) {
    if (!previousPageDisabled) {
      linkPrev = props.toLink.includes("?") ? "".concat(props.toLink) : "".concat(props.toLink, "?");
      linkPrev += "&page=".concat(props.page + -1, "&perPage=").concat(props.perPage);
    }

    if (!nextPageDisabled) {
      linkNext = props.toLink.includes("?") ? "".concat(props.toLink, "&") : "".concat(props.toLink, "?");
      linkNext += "page=".concat(props.page + 1, "&perPage=").concat(props.perPage);
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pagination-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "perPage-section col-xs-6"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    options: perPageValues,
    type: "custom",
    shapeSytle: "borderless",
    onChange: function onChange(event, input, option) {
      window.localStorage.setItem("pagination_component_init", option.value);
      props.onChange(event, parseInt(option.value), 1, "dropdown");
    }
  }), props.additionalComponent ? props.additionalComponent : null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pagination-section col-xs-6"
  }, totalPages === 1 ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "onePage"
  }, totalPages) : /*#__PURE__*/_react["default"].createElement("input", {
    onFocus: function onFocus(e) {
      e.target.select();
    },
    "data-test": "input",
    type: "text",
    onKeyDown: function onKeyDown(event) {
      if (event.keyCode === 13) {
        onUserInputChange(event);
      }
    },
    value: userPage,
    onChange: function onChange(e) {
      setUserPage(e.target.value);
    }
  }), props.ofText, " ", totalPages, props.toLink ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: linkPrev,
    title: "previous",
    className: "previousButton ".concat(previousPageDisabled ? "disabled" : ""),
    onClick: function onClick(e) {
      props.onChange(e, props.perPage, props.page - 1, "arrowDown");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow-head",
    className: "previous"
  })), /*#__PURE__*/_react["default"].createElement("a", {
    href: linkNext,
    title: "next",
    className: "next ".concat(nextPageDisabled ? "disabled" : ""),
    "data-test": "next",
    onClick: function onClick(e) {
      props.onChange(e, props.perPage, props.page + 1, "arrowUp");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow-head"
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "previousButton",
    disabled: previousPageDisabled,
    onClick: function onClick(e) {
      props.onChange(e, props.perPage, props.page - 1, "arrowDown");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow-head",
    className: "previous"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    disabled: nextPageDisabled,
    "data-test": "next",
    className: "next",
    onClick: function onClick(e) {
      props.onChange(e, props.perPage, props.page + 1, "arrowUp");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow-head"
  })))));
};

exports.Pagination = Pagination;
Pagination.propTypes = {
  perPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  values: _propTypes["default"].arrayOf(_propTypes["default"].number),
  ofText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  onChange: _propTypes["default"].func,
  perPage: _propTypes["default"].number,
  page: _propTypes["default"].number,
  currentCount: _propTypes["default"].number,
  additionalComponent: _propTypes["default"].any,
  toLink: _propTypes["default"].string
};
Pagination.defaultProps = {
  perPageText: "perPage",
  values: [25, 50, 100],
  ofText: "of",
  perPage: 25,
  page: 1,
  currentCount: 1,
  onChange: function onChange() {},
  toLink: null
};
var _default = Pagination;
exports["default"] = _default;